import { useEffect, useState } from "react";
import { http, formatApiError } from "../lib/api";
import { X, MapPin } from "lucide-react";

export function SitesAccessModal({ u, onClose, onSaved }) {
  const [sites, setSites] = useState([]);
  const [all, setAll] = useState(u.site_ids == null);
  const [sel, setSel] = useState(new Set(u.site_ids || []));
  const [q, setQ] = useState("");
  const [err, setErr] = useState("");
  useEffect(() => { http.get("/sites").then((r) => setSites(r.data)); }, []);
  const toggle = (id) => { const n = new Set(sel); n.has(id) ? n.delete(id) : n.add(id); setSel(n); };
  const shown = sites.filter((s) => `${s.name} ${s.city || ""}`.toLowerCase().includes(q.toLowerCase()));
  const save = async () => {
    try { await http.put(`/auth/users/${u.id}/sites`, { site_ids: all ? null : [...sel] }); onSaved(); onClose(); }
    catch (e) { setErr(formatApiError(e)); }
  };
  return (
    <div className="fixed inset-0 z-50 bg-slate-900/40 backdrop-blur-sm grid place-items-center p-4">
      <div className="bg-white rounded-md w-full max-w-lg border border-slate-200 max-h-[90vh] flex flex-col" onClick={(e) => e.stopPropagation()} data-testid="sites-access-modal">
        <div className="flex items-center justify-between px-5 py-4 border-b border-slate-200">
          <h3 className="font-display text-lg font-bold">Sites autorisés — {u.name}</h3>
          <button onClick={onClose} className="p-1 hover:bg-slate-100 rounded"><X className="h-4 w-4" /></button>
        </div>
        <div className="p-5 space-y-3 overflow-auto">
          <p className="text-xs text-slate-600">L&apos;utilisateur ne voit que ces sites dans les sites, le planning, les pointages, les rondes, la main courante, les rapports agents et les modèles de rapports.</p>
          <label className="flex items-center gap-2 text-sm font-semibold"><input data-testid="sites-access-all" type="checkbox" checked={all} onChange={(e) => setAll(e.target.checked)} />Tous les sites</label>
          {!all && <>
            <div className="flex items-center gap-2">
              <input data-testid="sites-access-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Rechercher un site" className="flex-1 border border-slate-300 rounded-md px-3 py-2 text-sm" />
              <button type="button" data-testid="sites-access-check-shown" onClick={() => setSel(new Set([...sel, ...shown.map((s) => s.id)]))} className="text-xs font-semibold text-sky-700 hover:underline">Tout cocher</button>
              <button type="button" data-testid="sites-access-uncheck" onClick={() => setSel(new Set())} className="text-xs font-semibold text-slate-500 hover:underline">Aucun</button>
            </div>
            <div className="text-xs text-slate-500">{sel.size} site(s) sélectionné(s)</div>
            <div className="grid sm:grid-cols-2 gap-1.5" data-testid="sites-access-list">
              {shown.map((s) => (
                <label key={s.id} className={`flex items-center gap-2 rounded-md border px-2.5 py-1.5 text-sm cursor-pointer transition-colors ${sel.has(s.id) ? "border-sky-300 bg-sky-50 text-sky-900" : "border-slate-200 text-slate-600"}`}>
                  <input type="checkbox" data-testid={`site-access-${s.id}`} checked={sel.has(s.id)} onChange={() => toggle(s.id)} /><MapPin className="h-3 w-3" /><span className="truncate">{s.name}</span>
                </label>
              ))}
            </div>
          </>}
          {err && <div className="text-sm text-rose-600 bg-rose-50 border border-rose-200 rounded-md px-3 py-2">{err}</div>}
        </div>
        <div className="flex justify-end gap-2 px-5 py-4 border-t border-slate-200 bg-slate-50">
          <button onClick={onClose} className="px-4 py-2 text-sm font-semibold border border-slate-300 rounded-md hover:bg-slate-100">Annuler</button>
          <button data-testid="sites-access-save" onClick={save} className="px-4 py-2 text-sm font-semibold bg-sky-600 hover:bg-sky-700 text-white rounded-md">Enregistrer</button>
        </div>
      </div>
    </div>
  );
}
